import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { News, History } from "./types/types";
import { getHistories, getNews } from "./api/api";
import { useEffect, useState } from "react";
import Main from "./components/main/Main";
import LoadingScreen from "./components/loading-screen/Loading-screen";
import Layout from "./components/layout/Layout";
import Cases from "./components/cases/Cases";
import Info from "./components/info/Info";
import Dev from "./components/dev/Dev";

const App = () => {
  const [loading, setLoading] = useState(false);
  const [histories, setHistories] = useState<History[] | null>([]);
  const [news, setNews] = useState<News[] | null>([]);

  useEffect(() => {
    const delayAndSetLoading = async () => {
      setLoading(true);

      try {
        (async () => {
          try {
            // const histories = await getHistories();
            // const news = await getNews();
            // setHistories(histories.data);
            // setNews(news.data);
            await new Promise((resolve) => setTimeout(resolve, 2600));
            setLoading(false);
          } catch (err) {
            await new Promise((resolve) => setTimeout(resolve, 2600));
            setLoading(false);
            throw err;
          } finally {
            setLoading(false);
          }
        })();
      } catch (err) {
        console.error("Ошибка при загрузке:", err);

        setLoading(false);
      }
    };

    delayAndSetLoading();
  }, []);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <Routes>
        <Route element={<Layout loading={loading} />}>
          <Route
            path="/"
            element={<Main news={news} histories={histories} />}
            // element={<Works />}
            index
          />
          <Route path="/cases" element={<Cases />} />
          <Route path="/services" element={<Dev />} />
          <Route path="/order" element={<Dev />} />
          <Route path="/cabinet" element={<Dev />} />
          <Route path="/info" element={<Info />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
